import { render, staticRenderFns } from "./UserRegistered.vue?vue&type=template&id=a9bde4fa&"
import script from "./UserRegistered.vue?vue&type=script&lang=js&"
export * from "./UserRegistered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports